import {
  AdTargetingType,
  AdvertisementTypeEnum,
  PageAdTargetingTypeEnum,
  PageAdTargetValue,
} from "@typings/Ads.d";

export const TABOOLA_PUBLISHER_ID = "sphmedia-tabla";

export const PERMUTIVE_SCRIPT =
  "https://5f876161-9740-4cc8-9b64-4585990b2690.edge.permutive.app/5f876161-9740-4cc8-9b64-4585990b2690-web.js";

export const DEFAULT_GOOGLE_SCRIPT_ID = "google_ads_script";
export const DEFAULT_GOOGLE_SCRIPT =
  "https://securepubads.g.doubleclick.net/tag/js/gpt.js";

/**
 * Configuration for Google Publisher Tag (GPT) slot sizes
 * Update new sizes here when needed
 * @see https://docs.google.com/spreadsheets/d/1G0vL9aitTVpPSfy18w8EexNCk1lFrSuKbm2g58K8c-E/edit#gid=0
 */
export const adSlotSizes: Record<string, googletag.GeneralSize> = {
  lb1: [
    [970, 250],
    [970, 90],
    [728, 90],
    [1, 1],
  ],
  lb2: [
    [970, 250],
    [970, 90],
    [728, 90],
    [1, 1],
  ],
  lb3: [
    [970, 250],
    [970, 90],
    [728, 90],
    [1, 1],
  ],
  imu1: [[1, 1], [300, 250], ["fluid"]],
  imu2: [[1, 1], [300, 250], [300, 600], ["fluid"]],
  midarticlespecial: [[1, 1], [300, 250], ["fluid"]],
};

export const pubPageAdTargeting: Partial<
  Record<PageAdTargetingTypeEnum, AdTargetingType<string, PageAdTargetValue>>
> = {
  home: { key: "page", value: PageAdTargetingTypeEnum.HOME },
  listing: { key: "page", value: PageAdTargetingTypeEnum.LISTING },
  article: { key: "page", value: PageAdTargetingTypeEnum.ARTICLE },
  tag: { key: "page", value: PageAdTargetingTypeEnum.TAG },
};

export const adTargetings: Partial<
  Record<AdvertisementTypeEnum, AdTargetingType[]>
> = {
  lb1: [
    { key: "pos", value: "1" },
    { key: "weight", value: "1" },
  ],
  lb2: [
    { key: "pos", value: "1" },
    { key: "weight", value: "1" },
  ],
  lb3: [
    { key: "pos", value: "1" },
    { key: "weight", value: "1" },
  ],
  imu1: [
    { key: "pos", value: "1" },
    { key: "weight", value: "6" },
  ],
  imu2: [
    { key: "pos", value: "2" },
    { key: "weight", value: "7" },
  ],
  midarticlespecial: [
    { key: "pos", value: "midarticlespecial" },
    { key: "weight", value: "5" },
  ],
  prestitial: [
    { key: "pos", value: "prestitial" },
    { key: "weight", value: "3" },
  ],
  catfish: [
    { key: "pos", value: "catfish" },
    { key: "weight", value: "2" },
  ],
};

export const AD_SLOT_PREFIX: string = "/5908/Tabla";

export const imu1AdSlotSizesInfinteScroll: Record<
  string,
  googletag.GeneralSize
> = {
  desktop: [[1, 1], [300, 250], ["fluid"]],
  mobile: [[1, 1], [300, 250], ["fluid"]],
};

export const midArticleAdSlotSizesInfinteScroll: Record<
  string,
  googletag.GeneralSize
> = {
  midArticle: [[1, 1], [300, 250], ["fluid"]],
};

export const companionLbAdSlotSizesInfinteScroll: Partial<
  Record<
    AdvertisementTypeEnum,
    { desktop: googletag.GeneralSize; mobile: googletag.GeneralSize }
  >
> = {
  lb1: {
    desktop: [
      [970, 250],
      [970, 90],
      [728, 90],
      [1, 1],
    ],
    mobile: [
      [300, 50],
      [320, 50],
      [320, 100],
      [320, 250],
      [1, 1],
    ],
  },
  lb2: {
    desktop: [
      [970, 250],
      [970, 90],
      [728, 90],
      [1, 1],
    ],
    mobile: [
      [320, 50],
      [320, 100],
      [300, 250],
      [1, 1],
    ],
  },
  lb3: {
    desktop: [
      [970, 250],
      [970, 90],
      [728, 90],
      [1, 1],
    ],
    mobile: [
      [320, 50],
      [320, 100],
      [300, 250],
      [1, 1],
    ],
  },
};

export const adSizeMappings: Partial<
  Record<AdvertisementTypeEnum, googletag.SizeMappingArray>
> = {
  lb1: [
    [
      [1024, 0],
      [
        [970, 250],
        [970, 90],
        [728, 90],
        [1, 1],
      ],
    ],
    [
      [768, 0],
      [
        [970, 250],
        [970, 90],
        [728, 90],
        [1, 1],
      ],
    ],
    [
      [320, 0],
      [
        [300, 50],
        [320, 50],
        [320, 100],
        [320, 250],
        [1, 1],
      ],
    ],
    [
      [0, 0],
      [
        [300, 50],
        [320, 50],
        [320, 100],
        [320, 250],
        [1, 1],
      ],
    ],
  ],
  lb2: [
    [
      [1024, 0],
      [
        [970, 250],
        [970, 90],
        [728, 90],
        [1, 1],
      ],
    ],
    [
      [768, 0],
      [
        [970, 250],
        [970, 90],
        [728, 90],
        [1, 1],
      ],
    ],
    [
      [320, 0],
      [
        [320, 50],
        [320, 100],
        [300, 250],
        [1, 1],
      ],
    ],
    [
      [0, 0],
      [
        [320, 50],
        [320, 100],
        [300, 250],
        [1, 1],
      ],
    ],
  ],
  lb3: [
    [
      [1024, 0],
      [
        [970, 250],
        [970, 90],
        [728, 90],
        [1, 1],
      ],
    ],
    [
      [768, 0],
      [
        [970, 250],
        [970, 90],
        [728, 90],
        [1, 1],
      ],
    ],
    [
      [320, 0],
      [
        [320, 50],
        [320, 100],
        [300, 250],
        [1, 1],
      ],
    ],
    [
      [0, 0],
      [
        [320, 50],
        [320, 100],
        [300, 250],
        [1, 1],
      ],
    ],
  ],
};

export const imu2AdSlotSizesQuickNews: Record<string, googletag.GeneralSize> = {
  desktop: [
    [300, 250],
    [300, 600],
  ],
  mobile: [[300, 250]],
};
